
import Vue from 'vue'
import App from './App.vue'
import 'element-ui/lib/theme-chalk/index.css'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import router from './router'
import store from './store'
import config from './common/config'
import './assets/css/common.css'
import './util/dialog'
import less from 'less'
import VueDND from 'awe-dnd'
import VDistpicker from 'v-distpicker'
import NoData from './components/common-components/NoData'
// WebSocket封装方法
import '../theme/index.css'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/swiper-bundle.css'
import '../src/icons'
import init from './common/init'
import VScaleScreen from 'v-scale-screen'
import { VueJsonp } from 'vue-jsonp'
Vue.use(VueJsonp)
Vue.use(VScaleScreen)
Vue.component('no-data', NoData)
Vue.component('v-distpicker', VDistpicker)
Vue.use(VueAwesomeSwiper, /* { default options with global component } */ )

Vue.use(VueDND)
Vue.use(ElementUI)
Vue.use(less)
Vue.config.productionTip = false
Vue.prototype.$var = {
    path: config.server,
    picPath: '127.0.0.1'

}
config.filters.forEach(f => {
    Vue.filter(f.filterName, f.func);
})
config.prototypes.forEach(p => {
    Vue.prototype[p.name] = p.val;
})
config.directives.forEach(d => {
    Vue.directive(d.name, d.parm);
})


init();

// 防抖处理-立即执行（如未使用请删除）
const on = Vue.prototype.$on
Vue.prototype.$on = function(event, func) {
    let timer
    let flag = true
    let newFunc = func
    if (event === 'click') {
        newFunc = function() {
            if (flag) {
                func.apply(this, arguments)
                flag = false
            }
            clearTimeout(timer)
            timer = setTimeout(function() {
                flag = true
            }, 1000)
        }
    }
    on.call(this, event, newFunc)
}


// 更新防抖节流事件
import utils from "./util/debouce"
Vue.prototype.$debouce = utils.debouce;
Vue.prototype.$throttle = utils.throttle;
new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')

export { router, store }


// WEBPACK FOOTER //
// ./src/main.js